import React, { useState } from 'react';
import CgvList from './CgvList';
import CgvUpload from './CgvUpload';
import CgvAuth from './CgvAuth';
import './cgv-manager.css';

const CgvManager = () => {
    const [refreshTrigger, setRefreshTrigger] = useState(0);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [credentials, setCredentials] = useState(null);

    const handleUploadSuccess = () => {
        setRefreshTrigger(prev => prev + 1);
    };

    const handleAuthSuccess = (authCredentials) => {
        setCredentials(authCredentials);
        setIsAuthenticated(true);
    };

    const handleLogout = () => {
        setIsAuthenticated(false);
        setCredentials(null);
    };

    if (!isAuthenticated) {
        return <CgvAuth onAuthSuccess={handleAuthSuccess} />;
    }

    return (
        <div className="cgv-manager">
            <header className="cgv-header">
                <h1>🗂️ Gestionnaire CGV</h1>
                <p>Interface de gestion des Conditions Générales de Vente</p>
                <p>
                    Cette interface est destinée à modifier uniquement les PDF actuellement présents dans la liste ci-dessous.
                    Pour tout ajout de nouveaux PDF, une intervention de l’équipe technique est nécessaire.
                </p>
                <button onClick={handleLogout} className="logout-btn">
                    Déconnexion
                </button>
            </header>

            <div className="cgv-content">
                <div className="cgv-section">
                    <CgvUpload 
                        onUploadSuccess={handleUploadSuccess} 
                        credentials={credentials}
                    />
                </div>

                <div className="cgv-section">
                    <CgvList 
                        refreshTrigger={refreshTrigger} 
                        credentials={credentials}
                    />
                </div>
            </div>
        </div>
    );
};

export default CgvManager; 